import React from 'react';

const Iframe = ({ mystyle, url, title }) => (
  <div>
    <iframe style={mystyle} src={url} title={title} />
  </div>
);

export default Iframe;
